import Loadable from 'react-loadable';
import { RouteLoading } from './RouteLoading';

const Dashboard = Loadable({
  loader: () => import('../views/Dashboard/GraficosDashboard'),
  loading: RouteLoading,
});

const RouteDashboard = [
  {
    path: '/dashboard',
    exact: true,
    name: 'Dashboard',
    component: Dashboard,
  },
];

export { RouteDashboard };
